import Star from '@/components/Icons/Star.vue';

export default {
    functional: true,

    name: 'StarredItem',

    render(h, { slots, props }) {
        return h('span', {
            class: [
                'starred',
                props.cssClass,
            ],
        },
        [
            slots().default,
            props.starred ? h(Star) : null,
        ]);
    },
}
